import { useQuery, useInfiniteQuery } from '@tanstack/react-query'
import { getArticleBanner, getArticleDetail, getArticleList, getArticleMore, getArticleCategory } from "./api"

export const useQueryArticleBanner = () => {
  return useQuery({
    queryKey: ['article-banner'],
    queryFn: () => getArticleBanner()
  })
}

export const useQueryArticleDetail = (id) => {
  return useQuery({
    queryKey: ['article-detail', id],
    queryFn: () => getArticleDetail(id),
    enabled: !!id
  })
}

export const useQueryArticleList = (params = {}) => {
  return useInfiniteQuery({
    queryKey: ['article-list', params],
    queryFn: ({ pageParam = 1 }) => getArticleList({ ...params, page: pageParam }),
    getNextPageParam: (lastPage, allPages) => {
      const limit = params._limit || 10;
      if (lastPage?.data?.data?.length < limit) {
        return undefined;
      }
      return allPages.length + 1;
    },
    initialPageParam: 1
  })
}

export const useQueryArticleMore = (id) => {
  return useQuery({
    queryKey: ['article-more', id],
    queryFn: () => getArticleMore(id),
    enabled: !!id
  })
}

export const useQueryArticleCategory = () => {
  return useQuery({
    queryKey: ['article-category'],
    queryFn: () => getArticleCategory()
  })
}
